import { useJpClassApi } from "../api/JpClassApiClient";
import { JpClassFrontendService } from "../services/JpClassFrontendService";

export const useJpClassService = (): JpClassFrontendService =>
  new JpClassFrontendService(useJpClassApi());
